import { Menu, Box, IconButton, Typography } from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useState } from "react";
import { setProductParams } from "../../features/catalog/catalogSlice";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import CheckboxButtons from "./CheckboxButtons";
import { categories } from "../models/categories";

export default function CategoryMenu() {
  
  const { productParams } = useAppSelector(state => state.catalog)
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const handleOpenCategoryMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };
  const handleCloseCategoryMenu = () => {
    setAnchorElMenu(null);
  };
  const dispatch = useAppDispatch()

    return (
      <Box sx={{ flexGrow: 1, display: 'flex' }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenCategoryMenu}
              color="inherit"
            >
              <FilterAltIcon />
              <Typography>Filter By Categories</Typography>
            </IconButton>
            <Menu
            id="menu-appbar"
            anchorEl={anchorElMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElMenu)}
            onClose={handleCloseCategoryMenu}
            sx={{
              display: 'block',
            }}
          >
              <CheckboxButtons
                      items={categories}
                      checked={productParams.categories}
                      onChange={(items: string[]) => dispatch(setProductParams({categories: items}))}
                  />
          </Menu>
      </Box>
      
    )
}